import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import {
  PaymentStatusActionTypes,
  PaymentStatusLoaded,
  PaymentStatusRequested,
  PaymentStatusLoadFailed,
} from '../actions/paymentStatus';
import { catchError, map, switchMap } from 'rxjs/operators';

import { BillingService } from '../../lib/services/billingService';
import { of } from 'rxjs';

@Injectable()
export class PaymentStatusEffects {
  @Effect()
  loadAllSteps$ = this.actions$.pipe(
    ofType<PaymentStatusRequested>(
      PaymentStatusActionTypes.paymentStatusRequested
    ),
    switchMap(action =>
      this.billingService.checkPaymentStatus(action.payload).pipe(
        map(paymentStatus => new PaymentStatusLoaded({ paymentStatus })),
        catchError(error => of(new PaymentStatusLoadFailed(error)))
      )
    )
  );

  constructor(
    private actions$: Actions,
    private billingService: BillingService
  ) {}
}
